// extracted by mini-css-extract-plugin
export default {"chart1":"Chart_chart1__jk463","chart2":"Chart_chart2__v016a","selectBox":"Chart_selectBox__yjNr1"};